import { Box, TextField, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";


export const NumberInput = ({name, isDisabled = false, title, handleInputChange, required = false, min = 0}) => {

    const { t } = useTranslation('global');

    return (
        <Box minWidth='calc(50% - 8px)'>
            <Typography variant='overline' color='secondary'>{t(`number.${title}`)}</Typography>
            <TextField 
                fullWidth
                name={title}
                size="small"
                variant="outlined"
                value={(name)}
                disabled={isDisabled}
                onChange={handleInputChange}
                required={required}
                type='number'
                InputProps={{ inputProps: { min, step:'any'} }}
            />
        </Box>
    )
}